<template>
  <div
    class="ajuda-container"
    @click="openView()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-headset-icon lucide-headset"
    >
      <title>Central de ajuda</title>
      <path
        d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"
      />
      <path d="M21 16v2a4 4 0 0 1-4 4h-5" />
    </svg>
  </div>
</template>
<script setup>
import router from "@/router";

function openView() {
  router.push("/central-ajuda");
}
</script>
<style scoped>
.ajuda-container {
  transition: 100ms;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--roxo-claro);
  border-radius: 50px;
  box-shadow: 2px 3px 8px rgba(0, 0, 0, 0.5);
  height: 60px;
  width: 60px;
  cursor: pointer;
}

.ajuda-container:hover {
  transition: 300ms;
  transform: translateY(-2px);
}
</style>
